import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type SeriesListQueryParams = Parameters<typeof SSF.api.seriesList>[0];

export const keys = createQueryKeySet<SeriesListQueryParams>('series');
const yearsKeys = createQueryKeySet('series-years');

export function useSeriesListQuery(params?: SeriesListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.seriesList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useSerieDetailsQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.seriesRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}

export function useSeriesListYearsQuery() {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.seriesListYearsRetrieve();
      return data;
    },
    queryKey: yearsKeys.all,
  });
}
